/* VikingsBrand sticky add-to-cart: shows a bottom bar once the main product form scrolls out of view;
   its button clicks the real Dawn submit so variant + cart drawer behaviour is preserved. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function boot() {
    var bar = document.querySelector('[data-vb-sticky]');
    var btn = bar && bar.querySelector('[data-vb-sticky-add]');
    var formId = btn && btn.getAttribute('data-form');
    var form = formId && document.getElementById(formId);

    if (bar && form) {
      var html = document.documentElement;
      var setShown = function (show) {
        bar.hidden = !show;
        /* vb-theme.css lifts the Shopify Inbox launcher above the bar while it shows */
        html.classList.toggle('vb-sticky-on', show);
        if (show) {
          html.style.setProperty('--vb-sticky-h', bar.offsetHeight + 8 + 'px');
          if (window.vbChatFix) window.vbChatFix();
        }
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            // show only when the form has scrolled ABOVE the viewport
            setShown(!(e.isIntersecting || e.boundingClientRect.top > 0));
          });
        }, { threshold: 0 });
        io.observe(form);
      }

      btn.addEventListener('click', function () {
        var real = form.querySelector('[type="submit"]:not([disabled])') || form.querySelector('[type="submit"]');
        if (real) { real.click(); }
        else if (form.requestSubmit) { form.requestSubmit(); }
      });
    }

    /* Variant change: the bar price, the sticky button, the main button's "Add to cart, $x"
       label (Dawn resets it to plain "Add to cart") and the Buy it now button all follow the
       selected variant instead of the one the page loaded with. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { // const in constants.js, not on window
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var d = event && event.data;
        if (!d) return;
        var variant = d.variant;
        var available = !!(variant && variant.available);

        var src = d.html && d.html.getElementById('ProductSubmitButton-' + d.sectionId);
        var dst = document.getElementById('ProductSubmitButton-' + d.sectionId);
        if (src && dst && available) {
          var s = src.querySelector('span');
          var t = dst.querySelector('span');
          if (s && t) t.textContent = s.textContent.trim();
        }

        if (bar && variant) {
          var price = bar.querySelector('.vb-sticky-atc__price');
          if (price) price.textContent = money(variant.price);
        }
        if (btn) {
          btn.disabled = !available;
          btn.textContent = available
            ? (window.variantStrings && window.variantStrings.addToCart) || btn.textContent
            : (window.variantStrings && window.variantStrings.soldOut) || btn.textContent;
        }
        document.querySelectorAll('[data-vb-buynow]').forEach(function (b) { b.hidden = !available; });
      });

      /* Buy it now finishes here: Dawn's add succeeded, so go straight to checkout */
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'product-form') return;
        var pending = document.querySelector('form[data-vb-checkout]');
        if (!pending) return;
        pending.removeAttribute('data-vb-checkout');
        window.location.href = root + 'checkout';
      });
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        document.querySelectorAll('form[data-vb-checkout]').forEach(function (f) { f.removeAttribute('data-vb-checkout'); });
        document.querySelectorAll('[data-vb-buynow][aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* "Buy it now": goes through the real form submit, so everything the form carries reaches the
     cart (engraving lines from vb-engraving.js, the custom ring size, the chosen quantity) and the
     submit-time checks still run. The old version posted only the variant id, which dropped the
     engraving and the ring size. It adds to the existing cart (a /cart/{id}:{qty} permalink
     would REPLACE it), then cartUpdate above, or vb-engraving.js, sends the shopper to checkout. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vb-buynow]');
    if (!b) return;
    var form = document.getElementById(b.getAttribute('data-vb-buynow'));
    if (!form || b.getAttribute('aria-busy') === 'true') return;
    var real = form.querySelector('[type="submit"]');
    if (!real || real.disabled || real.getAttribute('aria-disabled') === 'true') return;

    form.setAttribute('data-vb-checkout', '');
    b.setAttribute('aria-busy', 'true');
    real.click();
    /* a submit-time check (e.g. the required custom ring size) stopped the add: stay on the page */
    if (!real.classList.contains('loading') && real.getAttribute('aria-busy') !== 'true') {
      form.removeAttribute('data-vb-checkout');
      b.removeAttribute('aria-busy');
    }
  });
})();
